import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManualMatchesService {

  constructor(public http : HttpClient) { }
  baseUrl = environment.baseUrl

  matchUserList(obj:any,token:any) {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken":token
      })
    }
    return this.http.get(this.baseUrl + `/getAvailableUserList?limit=${obj.limit}&offset=${obj.offset}&search=${obj.search}`,httpOptions);
  }

  matchAdd(obj:any,token:any){
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken":token,
        "Content-Type":"application/json"
      })
    }
    return this.http.post(this.baseUrl + `/manualPushMatchesToUser`,obj, httpOptions);
  }

}
